/**
 * spiceNoteVocabulary — the FRONTEND mirror of the SPICE proposal-type
 * labels (api/_shared/spiceNoteVocabulary.ts SPICE_TYPE_LABELS). Kept
 * separate from noteVocabulary.ts (the pinned 16-type clinical mirror,
 * tests/ui/NoteVocabularyConformance.test.ts) on the same reasoning that
 * file's own header gives for every FE↔api mirror: a wholly separate
 * proposal set gets a wholly separate mirror, so neither side's drift
 * guard has to reason about the other's vocabulary.
 */

export type SpiceNoteProposalType =
  | 'spice_activity'
  | 'spice_session_summary'
  | 'spice_decline'
  | 'spice_next_plan'
  | 'spice_status_change'
  | 'spice_care_notice';

export const SPICE_PROPOSAL_TYPES: readonly SpiceNoteProposalType[] = [
  'spice_activity',
  'spice_session_summary',
  'spice_decline',
  'spice_next_plan',
  'spice_status_change',
  'spice_care_notice',
];

export function isSpiceNoteProposalType(v: string): v is SpiceNoteProposalType {
  return (SPICE_PROPOSAL_TYPES as readonly string[]).includes(v);
}

/** Plain labels the review queue renders — no acronym-humanize pass,
 *  these are the exact words the guide's tests pin. */
export const SPICE_TYPE_LABELS: Readonly<Record<SpiceNoteProposalType, string>> = {
  spice_activity: 'Activity',
  spice_session_summary: 'How the session went',
  spice_decline: 'Declined today',
  spice_next_plan: 'Plan for next time',
  spice_status_change: 'Schedule change',
  spice_care_notice: 'For the care manager',
};
